import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { sureClone } from "@/lib/DataUtils";
import { createStore } from "./storeHelper";
import _ from "lodash";

const debug = _debug(
  `${process.env.VUE_APP_PREFIX}:AnnouncementCategoriesStore`,
);

export const useAnnouncementCategoriesStore = defineStore(
  "announcementCategories",
  createStore({
    state: {
      announcementCategories: {},
      editor: {},
    },

    getters: {
      announcementCategoriesList: (state) =>
        _.values(state.announcementCategories),
      announcementCategoryById: (state) => (id) =>
        state.announcementCategories[id],
      editorChanges() {
        return this.getEditorChanges("announcementCategories");
      },
      editorHasChanges() {
        const diff = this.editorChanges;
        return diff && !_.isEmpty(diff);
      },
    },

    actions: {
      addAnnouncementCategory(category) {
        this.announcementCategories[category.id] = category;
      },

      clearCategories() {
        this.announcementCategories = {};
      },

      deleteCategory(categoryId) {
        delete this.announcementCategories[categoryId];
      },

      async load() {
        debug("load");
        const categories = await ApiClient.get(`/announcementCategories`);
        debug("load", categories);
        this.set("announcementCategories", _.keyBy(categories, "id"));
      },

      async loadCategoryToEditor(categoryId) {
        debug("loadCategoryToEditor", categoryId);
        const category = this.announcementCategories[categoryId];
        if (!category) {
          throw new Error("Category not found");
        }
        this.set("editor", sureClone(category));
      },

      async saveAnnouncementCategoryInEditor() {
        if (!this.editorHasChanges) {
          debug("saveAnnouncementCategoryInEditor", "No changes to save");
          return;
        }

        const categoryId = this.editor.id;
        const result = await ApiClient.put(
          `/announcementCategories/${categoryId}`,
          this.editor,
        );

        if (result) {
          this.addAnnouncementCategory(result);
        }
      },
    },
  }),
);
